import React from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Stack,
  SxProps,
} from '@mui/material';

interface ActionBarProps {
  title: React.ReactNode | string;
  actions?: React.ReactNode;
  sx?: SxProps; // Add sx prop for custom styling
}

export const ActionBar: React.FC<ActionBarProps> = ({ title, actions, sx }) => {
  return (
    <AppBar
      position="sticky"
      sx={{
        top: 64,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          background: '#dfdfdf',
          ...sx, // Merge custom styles with default styles
        }}
      >
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          flex={1}
          justifyContent="space-between"
        >
          <Box flex={1}>
            {typeof title === 'string' ? (
              <Typography
                variant="h6"
                sx={{
                  color: 'black',
                  lineHeight: 1,
                }}
              >
                {title}
              </Typography>
            ) : (
              title
            )}
          </Box>
          <Box>{actions}</Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
